import { render, staticRenderFns } from "./VerticalListSlider.vue?vue&type=template&id=47393a32&scoped=true&"
import script from "./VerticalListSlider.vue?vue&type=script&lang=js&"
export * from "./VerticalListSlider.vue?vue&type=script&lang=js&"
import style0 from "./VerticalListSlider.vue?vue&type=style&index=0&id=47393a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47393a32",
  null
  
)

export default component.exports